module.exports = __webpack_public_path__ + "img/phoneLogo.af6f080a.png";